import { AxiosRequestHeaders } from 'axios';
import { getUserToken } from '../../modules/Login/helpers/storage';

export default function authHeader(): AxiosRequestHeaders {
  const token = getUserToken() || '';
  if (token) {
    return { Authorization: 'Bearer ' + token };
  } else {
    return {};
  }
}
